"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _default(props) {
  var _props$onSave = props.onSave,
      onSave = _props$onSave === void 0 ? function () {} : _props$onSave,
      _props$onCancel = props.onCancel,
      onCancel = _props$onCancel === void 0 ? function () {} : _props$onCancel,
      disabled = props.disabled,
      className = props.className,
      saveLabel = props.saveLabel,
      cancelLabel = props.cancelLabel,
      size = props.size;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('field', 'is-grouped', 'form-controls', className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "control"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({}, props, {
    onClick: onSave
  }), saveLabel || 'Save')), /*#__PURE__*/_react.default.createElement("div", {
    className: "control"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onCancel,
    text: true
  }, cancelLabel || 'Cancel')));
}